/** @typedef {import('./definitions').TLanguages} TLanguages */
/** @typedef {import('./definitions').TLangTitles} TLangTitles */

/** @type {TLanguages} */
const LANGUAGES = [
  'hu', // magyar
  'en', // angol
  'de', // német
  'es', // spanyol
  'pl', // lengyel
  'si', // szlovén
  'rs', // szerb
  'sk', // szlovák
  'ua', // ukrán
  'ro'  // román
]

/** @type {TLangTitles} */
const LANG_TITLES = {
  hu: 'magyar',
  en: 'english',
  de: 'deutsch',
  es: 'español',
  pl: 'polski',
  si: 'slovenski',
  rs: 'русский',
  sk: 'slovenský',
  ua: 'український',
  ro: 'română'
}

module.exports = { LANGUAGES, LANG_TITLES }
